import { isNaN } from 'lodash';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { SessionStorageUtilities } from './StorageUtilities';
import useSingletonValue from './UseSingletonValue';

const MAX_ROWS = 1000;
const ROW_OVERRIDE_SESSION_STORAGE_KEY = 'dataTableVisibleRowsOverride';

/**
 * Returns whether or not we are in print mode. This happens in two cases:
 *
 * - We are in print media mode
 * - We are generating a PDF. We set `sessionStorage.printing = true` in that case, which this
 *   method is checking for.
 *
 * @returns {boolean}
 */
export default function useIsPrinting() {
    const isPrintMedia = useMediaQuery('@media print');
    const isPrinting = useSingletonValue(() => !!SessionStorageUtilities.getValue('printing'));
    return isPrintMedia || isPrinting;
}

/**
 * Returns the list row override to use when printing.
 *
 * @param {Number} maxRows The maximum allowed rows.  Defaults to 1000.
 *
 * @returns {Number} The row override value or null if no override was found.
 */
export function getPrintRowOverride(maxRows = MAX_ROWS) {
    const valStr = SessionStorageUtilities.getJSONValue(ROW_OVERRIDE_SESSION_STORAGE_KEY);

    if (valStr) {
        const val = parseInt(valStr, 10);

        return isNaN(val) || val > maxRows ? null : val;
    }

    return null;
}
